// Filename - components/SidebarData.js

import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

export const SidebarData = (tienePermiso) => [
    {
        title: "Polizas",
        path: "/polizas",
        icon: <AiIcons.AiFillInsurance />,
    },
    {
        title: "Clientes",
        path: "/clientes",
        icon: <AiIcons.AiFillHome />,
    },
    {
        title: "Clientes Potenciales",
        path: "/clientes_potenciales",
        icon: <AiIcons.AiFillHome />,
    },
    {
        title: "Compañías",
        path: "/companias",
        icon: <AiIcons.AiFillBank />,
    },
    /*{
        title: "Services",
        path: "/services",
        icon: <IoIcons.IoIosPaper />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,

        subNav: [
            {
                title: "Service 1",
                path: "/services/services1",
                icon: <IoIcons.IoIosPaper />,
                cName: "sub-nav",
            },
            {
                title: "Service 2",
                path: "/services/services2",
                icon: <IoIcons.IoIosPaper />,
                cName: "sub-nav",
            },
            {
                title: "Service 3",
                path: "/services/services3",
                icon: <IoIcons.IoIosPaper />,
            },
        ],
    },
    {
        title: "Contact",
        path: "/contact",
        icon: <FaIcons.FaPhone />,
    },*/
    {
        title: "Administración",
        /*path: "/administracion",*/
        icon: <FaIcons.FaEnvelopeOpenText />,

        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
            subNav: [
                tienePermiso && {
                    title: "Usuarios",
                    path: "/administracion/usuarios",
                    icon: <IoIcons.IoMdPerson />,
                },
                tienePermiso && {
                    title: "Roles",
                    path: "/administracion/roles",
                    icon: <IoIcons.IoIosLock />,
                },
                {
                    title: "Documentos",
                    path: "/administracion/documentos",
                    icon: <IoIcons.IoMdDocument />,
                }
            ].filter(Boolean),
    },
    /*{
        title: "Support",
        path: "/support",
        icon: <IoIcons.IoMdHelpCircle />,
    },*/
];